// CSRF 토큰 소스 단일화.
//
// 문제: <meta name="csrf-token">은 최초 페이지 로드 시점 토큰으로 고정된다.
// Inertia SPA로 오래 머무는 동안 서버가 토큰을 갱신(매 응답 XSRF-TOKEN 쿠키 재발급)하면
// meta 토큰은 stale 해진다. 그러면 raw fetch가 그 stale 토큰을 보내 CSRF 검증 실패 →
// protect_from_forgery(:null_session)가 세션을 비움 → 인증 실패 → /login 리다이렉트.
//
// 해결: 서버가 매 응답마다 갱신하는 XSRF-TOKEN 쿠키를 우선 사용한다(항상 최신).
// 쿠키가 없을 때만 meta 태그로 폴백한다.
//
// 헤더명은 기존대로 X-CSRF-Token을 유지한다 — Rails RequestForgeryProtection이
// 확실히 인식하는 헤더다. XSRF-TOKEN 쿠키 값은 유효한 마스킹 토큰이므로 Rails가
// unmask 후 세션 토큰과 비교해 통과시킨다.

function readXsrfCookie(): string | null {
  const match = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]+)/)
  if (!match) return null
  try {
    // 쿠키 값은 URL-encoded 이므로 디코드해야 Rails가 받는 raw 토큰이 된다.
    return decodeURIComponent(match[1])
  } catch {
    return match[1]
  }
}

function readMetaToken(): string | null {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || null
}

// 최신 CSRF 토큰. XSRF-TOKEN 쿠키(매 응답 갱신) 우선, 없으면 meta 폴백.
export function getCsrfToken(): string {
  return readXsrfCookie() || readMetaToken() || ''
}
